import { render } from "./Schema.vue?vue&type=template&id=f14680e2&scoped=true"
import script from "./Schema.vue?vue&type=script&lang=js"
export * from "./Schema.vue?vue&type=script&lang=js"

import "./Schema.vue?vue&type=style&index=0&id=f14680e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f14680e2"]])

export default __exports__